var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurnActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5078 2.17871C13.317 3.06491 13.9629 4.19574 14.5547 5.42188C14.8729 6.08127 15.0928 6.97411 15.0928 7.67285C15.0927 8.77165 14.7016 9.76554 14.3115 10.4775C13.9923 11.0601 14.2249 11.6556 14.5557 11.9648C14.728 12.1259 14.9762 12.2642 15.2812 12.2891C15.609 12.3157 15.9287 12.2035 16.1719 11.9814C16.7525 11.4512 17.3419 10.8145 17.8467 10.2012C18.528 11.4163 19.0038 12.9284 19.0039 14.1426C19.0039 18.0028 15.8618 21.1455 12.002 21.1455C8.81016 21.1453 6.02494 18.9837 5.22949 15.8877C5.07571 15.2882 5 14.7006 5 14.1426C5.00006 13.1651 5.19944 12.2221 5.5957 11.3281L5.77734 10.9482C6.28011 9.9718 7.09556 8.92695 8.80859 7.32324C10.2529 5.97112 11.71 4.17738 12.5078 2.17871Z",
    stroke: "#DC2626",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnActivity);
export default __webpack_public_path__ + "static/media/burn-activity.c7334811057cf325673470098a28ed24.svg";
export { ForwardRef as ReactComponent };